import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OnboardingFabComponent } from './onboarding-fab.component';

@NgModule({
    declarations: [OnboardingFabComponent],
    imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
    exports: [OnboardingFabComponent],
})
export class OnboardingFabModule {}
